// blog js

document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.getElementById('blog-search-input');
  const resultsContainer = document.getElementById('search-results-container');

  if (!searchInput || !resultsContainer) {
    return; 
  }

  let articles = [];

  try {
    const jsonData = document.getElementById('blog-articles-json')?.textContent;
    if (jsonData) {
      articles = JSON.parse(jsonData);
    }
  } catch (e) {
  }

  searchInput.addEventListener('input', function () {
    const query = this.value.trim().toLowerCase();

    if (query.length > 0) {
      const filtered = articles.filter(article =>
        article.title.toLowerCase().includes(query)
      );
      displayResults(filtered);
    } else {
      resultsContainer.style.display = 'none';
      resultsContainer.innerHTML = '';
    }
  });

  function displayResults(results) {
    resultsContainer.innerHTML = '';

    if (results.length > 0) {
      results.forEach(result => {
        const div = document.createElement('div');
        div.innerHTML = `<a href="${result.url}">${result.title}</a>`;
        resultsContainer.appendChild(div);
      });
      resultsContainer.style.display = 'block';
    } else {
      resultsContainer.style.display = 'none';
    }
  }

  document.addEventListener('click', function (event) {
    if (!searchInput.contains(event.target) && !resultsContainer.contains(event.target)) {
      resultsContainer.style.display = 'none';
    }
  });
});


// product category js start

  document.querySelectorAll('.main-category-product .cate-card').forEach((card) => {
    const image = card.querySelector('.cate-image');
    let targetX = 0,
      targetY = 0;
    let currentX = 0,
      currentY = 0;
    let targetRotate = 0,
      currentRotate = 0;
    const smoothing = 0.08;
    let isHover = false;

    card.addEventListener('mousemove', (e) => {
      isHover = true;
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      targetX = (x / rect.width - 0.5) * 100;
      targetY = (y / rect.height - 0.5) * 50;

      targetRotate = 20;
    });

    card.addEventListener('mouseleave', () => {
      isHover = false;
      targetX = 0;
      targetY = 0;
      targetRotate = 0;
    });

    function animate() {
      currentX += (targetX - currentX) * smoothing;
      currentY += (targetY - currentY) * smoothing;

      currentRotate += (targetRotate - currentRotate) * smoothing;

      image.style.transform = `translate(${currentX}px, ${currentY}px) rotate(${currentRotate}deg)`;

      requestAnimationFrame(animate);
    }

    animate();
  });


  // collection list

document.querySelectorAll('.ui-test-collection-list .resource-list__item').forEach(item => {
  const wrapper = item.querySelector('.ui-test-collection-list .category-icon-wrapper'); 
  const icon = item.querySelector('.ui-test-collection-list .category-icon');

  let targetX = 50, targetY = 50; 
  let currentX = 50, currentY = 50; 

  item.addEventListener('mousemove', (e) => {
    const rect = item.getBoundingClientRect();
    const xPercent = (e.clientX - rect.left) / rect.width;  
    const yPercent = (e.clientY - rect.top) / rect.height; 

    targetX = xPercent * 100;  
    targetY = yPercent * 100;
  });

  item.addEventListener('mouseleave', () => {
    targetX = 50; 
    targetY = 50;
    wrapper.style.opacity = 0;
  });

  function animate() {
    currentX += (targetX - currentX) * 0.2; 
    currentY += (targetY - currentY) * 0.2;

    icon.style.left = currentX + "%";
    icon.style.top = currentY + "%";
    icon.style.transform = "translate(-50%, -50%)";

    requestAnimationFrame(animate);
  }
  animate();
});



// compare code start 

document.addEventListener('click', function(e) {
  const btn = e.target.closest('.compare_button');
  if (!btn) return;

  const productData = {
    title: btn.dataset.title,
    image: btn.dataset.image,
    description: btn.dataset.description,
    type: btn.dataset.type,
    vendor: btn.dataset.vendor,
    price: btn.dataset.price,
    availability: btn.dataset.availability,
    url: btn.dataset.url
  };

  let compareProducts = JSON.parse(localStorage.getItem('compareProducts') || '[]');

  // Limit check (max 3 products)
  if (compareProducts.length >= 3) {
    showCompareLimitPopup();
    return;
  }

  if (!compareProducts.some(p => p.title === productData.title)) {
    compareProducts.push(productData);
    localStorage.setItem('compareProducts', JSON.stringify(compareProducts));
  }

  window.location.href = '/pages/compare';
});

// Popup function
function showCompareLimitPopup() {
  const popup = document.createElement('div');
  popup.classList.add('compare-limit-modal');
  popup.innerHTML = `
    <div class="modal-overlay"></div>
    <div class="modal-container">
    
      <div class="modal-body">
        <p class="modal-message">Maximum products to compare. Limit is 3!</p>
        <div>
        <button class="close-btn modal-close modal__close-button">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x icon icon-close" aria-hidden="true" focusable="false" role="presentation"><path d="M18 6 6 18M6 6l12 12"></path></svg>
        </button>
        </div>        
      </div>
      <button class="button button-hover-style button-primary modal-compare-btn">Compare</button>
    </div>
  `;
  document.body.appendChild(popup);

  // Close popup
  popup.querySelector('.modal-close').addEventListener('click', () => popup.remove());
  popup.querySelector('.modal-overlay').addEventListener('click', () => popup.remove());
  popup.querySelector('.modal-compare-btn').addEventListener('click', () => {
    window.location.href = '/pages/compare';
  });
}

// CSS for modal
const style = document.createElement('style');
style.innerHTML = `
.compare-limit-modal {
      position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.5);
}
.compare-limit-modal .modal-compare-btn {
    float: right;
    padding: 0.6rem 1.6rem;
    font-size: 1rem;
}

.compare-limit-modal .modal-overlay {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.4);
}

.compare-limit-modal .modal-container {
    position: relative;
    background: #fff;
    max-width: 560px;
    z-index: 10;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
    width: 100%;
    margin: 0 auto;
    padding: 10px;
}
.compare-limit-modal .modal-body {
    text-align: center;
    display: flex;
    align-items: center;
    padding: 0 0 10px;
    border-bottom: 1px solid #dee2e6;
    margin-bottom: 1.4rem;
      justify-content: space-between;
    }

.compare-limit-modal .modal-message {
       font-size: 1.1rem;
    margin: 0;
    color: rgba(var(--color-foreground));
    font-family: var(--font-heading-family);
}
  .compare-limit-modal .close-btn {
    background: transparent;
    border: 0;
        cursor: pointer;
}


/* Responsive */
@media (max-width: 480px) {
  .compare-limit-modal .modal-message {
    font-size: 14px;
  }
  .compare-limit-modal .modal-compare-btn {
    width: 100%;
  }
}
`;
document.head.appendChild(style);

// end compare code

// collection add to cart button code
(function () {
        var formId = '{{ product_form_id }}';
        var form = document.getElementById(formId);
        if (!form) return;

        // If typical theme product form handler exists, don't override (best-effort detection).
        // (Different themes use different handlers — this check is conservative.)
        if (window.ProductForm || (window.theme && window.theme.ProductForm)) {
          return;
        }

        form.addEventListener('submit', function (e) {
          e.preventDefault();

          var formData = new FormData(form);
          var variantId = formData.get('id');
          var quantity = parseInt(formData.get('quantity') || '1', 10);

          if (!variantId) {
            console.warn('QuickAdd: no variant id present — cannot add to cart.');
            form.submit(); // fallback to regular submit
            return;
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: quantity }),
          })
            .then(function (res) {
              if (!res.ok) throw new Error('Add to cart failed');
              return res.json();
            })
            .then(function () {
              // fetch cart and dispatch an event so any drawer can update
              return fetch('/cart.js');
            })
            .then(function (res) {
              return res.json();
            })
            .then(function (cart) {
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
              // Try to open cart drawer if your theme has a toggle element
              var openBtn = document.querySelector(
                '[data-open-cart-drawer], [data-cart-toggle], .cart-toggle, .cart-drawer__open'
              );
              if (openBtn) {
                // Some themes expect a click; others listen to custom events.
                openBtn.click();
              }
            })
            .catch(function (err) {
              console.error('QuickAdd add-to-cart error:', err);
              // Last resort: submit normally to let server handle
              form.submit();
            });
        });
      })();

// size chart popup
document.addEventListener("DOMContentLoaded", function() {
  const modal = document.querySelector(".sizeModal");
  const openBtn = document.querySelector(".openSizeChart");
  const closeBtn = modal ? modal.querySelector(".custom-close") : null;

  if (!modal || !openBtn || !closeBtn) return; // stop if elements missing

  openBtn.addEventListener("click", function(e) {
    e.preventDefault();
    modal.style.display = "block";
  });

  closeBtn.addEventListener("click", function() {
    modal.style.display = "none";
  });

  window.addEventListener("click", function(e) {
    if (e.target === modal) {
      modal.style.display = "none";
    }
  });
});


// notify me button js

document.addEventListener("DOMContentLoaded", function () {
  const notifyButton = document.querySelector(".notify-me-button");
  const notifyOverlay = document.querySelector(".notify-popup-overlay");
  const closeBtn = document.querySelector(".close-popup");

  if (notifyButton && notifyOverlay) {
    notifyButton.addEventListener("click", function (e) {
      e.preventDefault();
      notifyOverlay.style.display = "flex"; // show modal
    });
  }

  if (closeBtn && notifyOverlay) {
    closeBtn.addEventListener("click", function () {
      notifyOverlay.style.display = "none"; // hide modal
    });
  }

  // Close if click outside the modal content
  if (notifyOverlay) {
    notifyOverlay.addEventListener("click", function (e) {
      if (e.target === notifyOverlay) {
        notifyOverlay.style.display = "none";
      }
    });
  }
});


// color swatch js start

document.addEventListener("click", function (e) {
  if (e.target.matches(".color-swatch-btn")) {
    const swatch = e.target;
    const imageUrl = swatch.dataset.image;
    const productCard = swatch.closest(".product-card");
    const mainImg = productCard.querySelector(".product-media-container img");

    if (mainImg && imageUrl) {
      mainImg.src = imageUrl;
      mainImg.srcset = imageUrl;
    }

    // Toggle active class for highlight
    productCard.querySelectorAll(".color-swatch-btn").forEach(btn => btn.classList.remove("active"));
    swatch.classList.add("active");
  }
});

// add to cart button spinner js

(function() {
  // Time to fallback reset if no AJAX hook used (ms)
  const RESET_TIMEOUT = 2500;

  function showSpinnerForButton(button) {
    if (!button) return;
    const spinner = button.querySelector('.cart-spinner');
    const preorderText = button.querySelector('.preorder-text');
    const addToCartText = button.querySelector('.add-to-cart-text__content');
    if (!spinner) return;

    // Hide texts if present
    if (preorderText) preorderText.style.display = 'none';
    if (addToCartText) addToCartText.style.display = 'none';

    spinner.hidden = false;
    button.disabled = true;
    button.classList.add('is-loading');

    // Return a function to reset
    return function resetSpinner() {
      spinner.hidden = true;
      if (preorderText) preorderText.style.display = '';
      if (addToCartText) addToCartText.style.display = '';
      button.disabled = false;
      button.classList.remove('is-loading');
    };
  }

  // Global submit handler — use capture so we catch events early for dynamic forms
  document.addEventListener('submit', function(event) {
    try {
      const form = event.target;
      // Only care about product add-to-cart forms (heuristic)
      // Adjust selector if your forms don't use data-type or action
      const isAddToCartForm = form.matches('form[data-type="add-to-cart-form"], form[action*="/cart/add"]');

      if (!isAddToCartForm) return;

      // Get the actual button that submitted the form (supported in modern browsers)
      let button = event.submitter || form.querySelector('.add-cart-button, button[type="submit"], input[type="submit"]');

      // If no button found, search broader (some themes place button outside form)
      if (!button) {
        // Try to find nearest .add-cart-button by id reference or within document
        button = document.querySelector('.add-cart-button');
      }
      if (!button) return;

      // Show spinner & get reset function
      const reset = showSpinnerForButton(button);

      // If the site uses non-AJAX (full page reload), spinner will show during navigation.
      // If it's AJAX, you should call reset() when AJAX completes. We'll also set a safe fallback.
      if (typeof window.__shopify_addToCart_hook === 'function') {
        // If user provided a global hook, assume it will call reset when done.
        try {
          window.__shopify_addToCart_hook(form, button, reset);
        } catch (e) {
          // ignore hook errors
        }
      }

      // Fallback: reset after a timeout if not handled elsewhere
      setTimeout(function() {
        try { reset && reset(); } catch (e) { /* noop */ }
      }, RESET_TIMEOUT);

      // Let the submit proceed normally (don't preventDefault).
    } catch (err) {
      // Don't let errors stop the form submission
      console.error('Spinner submit handler error:', err);
    }
  }, true /* capture */);

  // Optional: expose a global function to reset spinner from your AJAX success callback:
  window.__reset_add_to_cart_spinner = function(button) {
    if (!button) return;
    const spinner = button.querySelector('.cart-spinner');
    const preorderText = button.querySelector('.preorder-text');
    const addToCartText = button.querySelector('.add-to-cart-text__content');
    if (spinner) spinner.hidden = true;
    if (preorderText) preorderText.style.display = '';
    if (addToCartText) addToCartText.style.display = '';
    button.disabled = false;
    button.classList.remove('is-loading');
  };
})();

